import script from "./installed-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./installed-detail.vue?vue&type=script&lang=ts&setup=true"

import "./installed-detail.vue?vue&type=style&index=0&id=79f26ee2&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f26ee2"]])

export default __exports__